import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { HashRouter, BrowserRouter } from 'react-router-dom'
import { Store } from './store';

import * as Sentry from '@sentry/browser';

import './index.css';
import * as serviceWorker from './serviceWorker';

import App from './views/App';

Sentry.init({dsn: "https://8ac8a5ef7f4a4dd382f5fe2075457b06@sentry.io/1838593"});

ReactDOM.render(
    <Provider store={Store}>
        <HashRouter>
            <App />
        </HashRouter>
    </Provider>
, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
